const PieChartSkeleton = () => (
  <div className="flex items-center justify-center h-[400px]">
    <div
      className="animate-pulse rounded-full BookEZ_card_bg_secondary_light"
      style={{ width: 180, height: 180 }}
    />
  </div>
);

export default PieChartSkeleton;
